/**
 * Publication Creation Renderer
 *
 * Displays creation batch process details:
 * operation description and count summary of publications being created.
 *
 * Data shape (from PublicationCreationBatchProcessStartedEventSchema):
 *   publications: any[]
 */

import { FC } from 'react';
import { Group, Stack, Text } from '@mantine/core';
import type { DetailRendererProps, OperationRendererConfig, ProcessData } from './index';

const DetailComponent: FC<DetailRendererProps> = ({ process, t }) => {
  const data = ( process.data || {}) as ProcessData;
  const publicationsCount = data.publications?.length ?? process.totalItems ?? 0;

  return (
    <Stack gap="sm">
      <Text fz="sm" c="dimmed">
        {t( 'batchProcesses_operations_PublicationCreation_description' )}
      </Text>

      <Group gap="xs">
        <Text fz="sm" fw={500}>
          {t( 'batchProcesses_renderer_publicationCount' )}:
        </Text>
        <Text fz="sm">
          {publicationsCount}
        </Text>
      </Group>
    </Stack>
  );
};

export const config: Omit<OperationRendererConfig, 'icon' | 'color' | 'labelKey'> = {
  getSummary: ( data, t ) => {
    const count = data?.publications?.length ?? 0;
    return t( 'batchProcesses_summary_publications', { count });
  },
  DetailComponent,
  getRequiredReferenceIds: () => ({})
};

export default DetailComponent;
